/**
 * Anleitungsseite: Sprungziele oeffnen, Suche, Fragen-Klappen,
 * Markierung im Verzeichnis.
 *
 * Das Verzeichnis und die Kacheln verweisen auf Abschnitte, die
 * zugeklappt sind. Ein Klick auf "iPhone" landete dort im Leeren: Der
 * Browser sprang an eine Stelle, an der nur die zusammengeklappte Zeile
 * stand. Manche Browser oeffnen <details> beim Ankersprung von selbst,
 * viele nicht — darauf ist kein Verlass.
 *
 * Gilt auch fuer Verweise im Text und fuer geteilte Links mit Anker.
 */
(function () {
  'use strict';

  /** Oeffnet das Ziel und alle Abschnitte darueber. */
  function oeffnen(ziel) {
    if (!ziel) return;

    var knoten = ziel;
    while (knoten && knoten !== document.body) {
      if (knoten.tagName === 'DETAILS') knoten.open = true;
      knoten = knoten.parentNode;
    }
  }

  function ausAdresse() {
    if (!window.location.hash) return;
    var ziel = document.getElementById(window.location.hash.slice(1));
    if (!ziel) return;

    oeffnen(ziel);
    // Erst nach dem Oeffnen scrollen: Vorher steht das Ziel noch an
    // einer anderen Stelle, weil die Abschnitte darueber zu sind.
    window.requestAnimationFrame(function () {
      ziel.scrollIntoView({ block: 'start' });
    });
  }

  /**
   * Oben beginnen, wenn die Seite frisch aufgerufen wird.
   *
   * Das Theme wechselt Seiten mit View Transitions. Dabei blendet die
   * neue Seite ein, waehrend die alte Scroll-Position noch steht — wer
   * unten im Footer auf "Anleitungen" klickt, landet deshalb mitten in
   * der Seite statt am Anfang.
   *
   * Bei Vor und Zurueck bleibt die Position erhalten: Dort will man
   * genau dorthin zurueck, wo man war. Ein Anker in der Adresse hat
   * ebenfalls Vorrang.
   */
  function obenBeginnen() {
    if (window.location.hash) return;

    var eintraege = performance.getEntriesByType
      ? performance.getEntriesByType('navigation')
      : [];
    if (eintraege.length && eintraege[0].type === 'back_forward') return;

    window.scrollTo(0, 0);

    // Zweiter Anlauf nach dem vollstaendigen Laden: Browser stellen
    // eine gemerkte Position teils erst dann wieder her und
    // ueberschreiben damit den ersten Versuch. Bilder und Schriften
    // aendern bis dahin ausserdem die Seitenhoehe.
    window.addEventListener(
      'load',
      function () {
        if (!window.location.hash) window.scrollTo(0, 0);
      },
      { once: true }
    );
  }

  /**
   * Fragen-Liste: Jede h3 samt dem Text bis zur naechsten h3 wird zu
   * einer eigenen Klappzeile. Im Editor bleibt es ein Feld mit
   * Ueberschriften; ohne Skript stehen Fragen und Antworten offen da.
   */
  function fragenKlappen(rahmen) {
    rahmen.querySelectorAll('.rxk-an-klapp--fragen > .rxk-an-inhalt').forEach(function (inhalt) {
      inhalt.querySelectorAll(':scope > h3').forEach(function (h3) {
        var frage = document.createElement('details');
        frage.className = 'rxk-an-frage';
        var kopf = document.createElement('summary');
        kopf.textContent = h3.textContent;
        frage.appendChild(kopf);

        var naechstes = h3.nextElementSibling;
        while (naechstes && naechstes.tagName !== 'H3') {
          var danach = naechstes.nextElementSibling;
          frage.appendChild(naechstes);
          naechstes = danach;
        }
        h3.replaceWith(frage);
      });
    });
  }

  /** Nimmt alle Treffer-Markierungen wieder heraus. */
  function markierungWeg(rahmen) {
    rahmen.querySelectorAll('mark.rxk-an-treffer').forEach(function (m) {
      var eltern = m.parentNode;
      eltern.replaceChild(document.createTextNode(m.textContent), m);
      eltern.normalize();
    });
  }

  /** Hebt das Suchwort im Text der Anleitung hervor. */
  function markieren(klapp, wort) {
    var lauf = document.createTreeWalker(klapp, NodeFilter.SHOW_TEXT);
    var knoten = [];
    while (lauf.nextNode()) knoten.push(lauf.currentNode);

    knoten.forEach(function (text) {
      var stelle = text.nodeValue.toLowerCase().indexOf(wort);
      // Rueckwaerts nicht noetig: Nach dem Teilen sucht die Schleife
      // im Rest weiter, bis nichts mehr passt.
      while (stelle !== -1) {
        var treffer = text.splitText(stelle);
        var rest = treffer.splitText(wort.length);
        var m = document.createElement('mark');
        m.className = 'rxk-an-treffer';
        treffer.parentNode.replaceChild(m, treffer);
        m.appendChild(treffer);
        text = rest;
        stelle = text.nodeValue.toLowerCase().indexOf(wort);
      }
    });
  }

  /**
   * Suche: blendet Kacheln und Anleitungen aus, in denen das Wort nicht
   * vorkommt. Die Kacheln direkt unter dem Feld sind damit die
   * Trefferliste.
   */
  function sucheVerdrahten(rahmen) {
    var feld = rahmen.querySelector('.rxk-an-suche__feld');
    if (!feld) return;

    var leer = rahmen.querySelector('.rxk-an-suche__leer');
    var zahl = rahmen.querySelector('.rxk-an-suche__zahl');
    var klappen = Array.prototype.slice.call(rahmen.querySelectorAll('.rxk-an-klapp'));

    function filtern() {
      var wort = feld.value.trim().toLowerCase();
      var treffer = 0;
      var passende = [];

      rahmen.classList.toggle('rxk-anl--sucht', wort !== '');
      markierungWeg(rahmen);

      // Was die Suche selbst aufgeklappt hat, klappt sie auch wieder zu.
      rahmen.querySelectorAll('.rxk-an-klapp[data-von-suche]').forEach(function (k) {
        k.open = false;
        k.removeAttribute('data-von-suche');
      });

      klappen.forEach(function (klapp) {
        var passt = wort === '' || klapp.textContent.toLowerCase().indexOf(wort) !== -1;
        klapp.hidden = !passt;
        if (passt) treffer++;
        if (passt && wort.length >= 2) {
          passende.push(klapp);
          markieren(klapp, wort);
        }

        var kachel = rahmen.querySelector('.rxk-an-kachel[href="#' + klapp.id + '"]');
        if (kachel) kachel.parentNode.hidden = !passt;

        // Bei den Fragen nur die zeigen, die das Wort enthalten.
        klapp.querySelectorAll('.rxk-an-frage').forEach(function (frage) {
          var drin = wort !== '' && frage.textContent.toLowerCase().indexOf(wort) !== -1;
          frage.open = drin;
        });
      });

      // Gruppen und Bereichstitel ohne sichtbaren Eintrag ausblenden.
      rahmen.querySelectorAll('.rxk-an-wahl__gruppe').forEach(function (gruppe) {
        gruppe.hidden = !gruppe.querySelector('li:not([hidden])');
      });
      rahmen.querySelectorAll('.rxk-an-teil').forEach(function (teil) {
        var sichtbar = false;
        var n = teil.nextElementSibling;
        while (n && !n.classList.contains('rxk-an-teil')) {
          if (n.classList.contains('rxk-an-klapp') && !n.hidden) sichtbar = true;
          n = n.nextElementSibling;
        }
        teil.hidden = !sichtbar;
      });

      // Bei ein oder zwei Treffern gleich aufklappen: Dann ist die
      // markierte Stelle ohne weiteren Klick zu sehen.
      if (passende.length <= 2) {
        passende.forEach(function (klapp) {
          if (klapp.open) return;
          klapp.open = true;
          klapp.setAttribute('data-von-suche', '');
        });
      }

      if (leer) leer.hidden = treffer > 0;
      if (zahl) {
        zahl.hidden = wort === '' || treffer === 0 || !zahl.dataset.text;
        zahl.textContent = (zahl.dataset.text || '').replace('[zahl]', treffer);
      }
    }

    feld.addEventListener('input', filtern);
    // Die Lupe auf der Handy-Tastatur soll die Tastatur schliessen,
    // damit die Treffer zu sehen sind.
    feld.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') feld.blur();
    });
  }

  /** Markiert im Verzeichnis den Abschnitt, der gerade im Blick ist. */
  function verzeichnisMarkieren(rahmen) {
    var links = rahmen.querySelectorAll('.rxk-an-verzeichnis li a[href^="#"]');
    if (!links.length || !('IntersectionObserver' in window)) return;

    var nachId = {};
    links.forEach(function (a) {
      nachId[a.getAttribute('href').slice(1)] = a;
    });

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            a.removeAttribute('aria-current');
          });
          nachId[e.target.id].setAttribute('aria-current', 'true');
        });
      },
      // Ein schmaler Streifen im oberen Drittel: Aktiv ist, was dort steht.
      { rootMargin: '-25% 0px -70% 0px' }
    );

    Object.keys(nachId).forEach(function (id) {
      var ziel = document.getElementById(id);
      if (ziel) beobachter.observe(ziel);
    });
  }

  /** "Zur Uebersicht" erscheint, sobald die Schnellwahl aus dem Bild ist. */
  function zurueckKnopf(rahmen) {
    var knopf = rahmen.querySelector('.rxk-an-zurueck');
    var wahl = rahmen.querySelector('.rxk-an-kopf');
    if (!knopf || !wahl || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (eintraege) {
      knopf.hidden = eintraege[0].isIntersecting;
    }).observe(wahl);
  }

  function verdrahten() {
    var rahmen = document.querySelector('.rxk-anl');
    if (!rahmen || rahmen.dataset.bereit === 'ja') return;
    rahmen.dataset.bereit = 'ja';

    obenBeginnen();
    fragenKlappen(rahmen);
    sucheVerdrahten(rahmen);
    verzeichnisMarkieren(rahmen);
    zurueckKnopf(rahmen);

    rahmen.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;

      var id = a.getAttribute('href').slice(1);
      if (!id) return;

      var ziel = document.getElementById(id);
      if (!ziel) return;

      e.preventDefault();
      // Ein Ziel, das die Suche gerade ausblendet, waere unerreichbar.
      if (ziel.hidden) ziel.hidden = false;
      oeffnen(ziel);

      window.requestAnimationFrame(function () {
        ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    ausAdresse();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verdrahten);
  } else {
    verdrahten();
  }

  window.addEventListener('hashchange', ausAdresse);
  document.addEventListener('shopify:section:load', verdrahten);
})();
